import { TypeOf } from "./type-of";

var getTargetElement = function (target, defaultElement) {
  if (!target) {
    return defaultElement;
  }

  var targetElement = undefined;

  if (TypeOf.isFunction(target)) {
    targetElement = target();
  } else if ("current" in target) {
    targetElement = target.current;
  } else {
    targetElement = target;
  }

  return targetElement;
};

export { getTargetElement };